import {initMainHeader} from '../js/src/header-init';
import {initRMA} from "../js/pages/rma-form";

import '../scss/pages/rma-form.scss';

initMainHeader();
initRMA();
